import { render, staticRenderFns } from "./indexTest.vue?vue&type=template&id=337b738a&scoped=true&"
import script from "./indexTest.vue?vue&type=script&lang=js&"
export * from "./indexTest.vue?vue&type=script&lang=js&"
import style0 from "./indexTest.vue?vue&type=style&index=0&id=337b738a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b738a",
  null
  
)

export default component.exports